import { gql, useQuery } from '@apollo/client';
import { getAccessToken } from 'utils/account';

type Product = {
  name: string;
};

export type OrganizationGraphQLResponse = {
  organization_id: string;
  name: string;
  products: Product[];
  whitelisted?: boolean;
  created_at: string;
};

const EMPTY_ARRAY = [];
export const GET_ORGANIZATIONS_LIST = gql`
  query ListOrganizations {
    ListOrganizations {
      organization_id
      name
      created_at
      whitelisted
      products {
        name
      }
    }
  }
`;

type UseOrganizations = {
  organizations: OrganizationGraphQLResponse[];
  isFetching: boolean;
};

export const useOrganizations = (): UseOrganizations => {
  const { data: organizations, loading } = useQuery<{
    ListOrganizations: OrganizationGraphQLResponse[];
  }>(GET_ORGANIZATIONS_LIST, {
    context: {
      headers: {
        Authorization: `Bearer ${getAccessToken()}`,
      },
    },
  });

  return {
    organizations: organizations?.ListOrganizations ?? EMPTY_ARRAY,
    isFetching: loading,
  };
};
